/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CmsLock(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CmsLock',
      'aria-hidden': true,
      focusable: false,
      width:  9 * scale,
      height: 13 * scale,
      viewBox: '0 0 9 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('path', {"fill":"#FFF2CC","d":"M1 7h7v5H1z"}),createElement('path', {"d":"M8 4.5a3.5 3.5 0 0 0-7 0V6h7z","fill":"#FFF"}),createElement('path', {"d":"M0 6.5v-2a4.5 4.5 0 0 1 9 0V13H0zm8-2a3.5 3.5 0 0 0-7 0V6h7zM1 7v5h7V7zm3 1h1v3H4z","fill":"#E6BE49"})))
}
